// extracted by mini-css-extract-plugin
export default {"wrap":"tF-z","fullWidth":"uF-z","hideOnDesktop":"vF-z","content":"wF-z","hasOpenedNav":"xF-z","crumbsList":"yF-z","dropdownsWrap":"zF-z"};